import styled from 'styled-components';

import { IconSolidPlane, theme } from '@notino/react-styleguide-v20';

export const StyledAirDeliveryForbidden = styled.div`
  display: flex;
  align-items: flex-start;
  padding-right: 0.25rem;
  margin-top: 0.25rem;
`;

export const StyledIconSolidPlane = styled(IconSolidPlane)`
  width: 1.25rem;
  height: 1.25rem;

  @media (max-width: ${theme.breakpoints.md}rem) {
    width: 1.5rem;
  }
`;
